import createPersistedState from "use-persisted-state";

const localStorageKey = "language";

export const useLanguageState = createPersistedState(localStorageKey);
